const getPartnerId = (partner) => partner && (partner.id || partner.companyId);

const getMappings = (partner) => {
  const mappings = partner && partner.misc && partner.misc.ti2Agents;
  if (!Array.isArray(mappings)) return [];
  return mappings.filter((mapping) => mapping && mapping.integrationId);
};

const findPartner = ({ partner, partners = [], partnerId }) => {
  if (getPartnerId(partner) === partnerId) return partner;
  return partners.find((candidate) => getPartnerId(candidate) === partnerId);
};

const findAppKey = (allAppKeys, partnerId) =>
  allAppKeys.find(
    (appKey) =>
      appKey &&
      appKey.integrationId &&
      appKey.hint === partnerId
  );

export const getConnectedPartners = ({
  partners = [],
  allAppKeys = [],
  toolId,
}) => {
  const partnersById = partners.reduce((byId, partner) => {
    const partnerId = getPartnerId(partner);
    if (partnerId) byId[partnerId] = partner;
    return byId;
  }, {});
  const connectedPartners = [];
  const connectedPartnerIds = new Set();
  const addPartner = (partnerId) => {
    if (!partnerId || connectedPartnerIds.has(partnerId)) return;
    const partner = partnersById[partnerId];
    connectedPartnerIds.add(partnerId);
    connectedPartners.push(partner || { id: partnerId, name: partnerId });
  };

  allAppKeys.forEach((appKey) => {
    if (!appKey || !appKey.integrationId) return;
    addPartner(appKey.hint);
  });
  partners.forEach((partner) => {
    const mapping = getMappings(partner).find(
      (candidate) => !toolId || candidate.tool === toolId
    );
    if (mapping) addPartner(getPartnerId(partner));
  });

  return connectedPartners;
};

export const findIntegrationApp = ({
  allAppKeys = [],
  partner,
  partners = [],
  partnerId,
  toolId,
}) => {
  if (!partnerId) return '';
  const appKey = findAppKey(allAppKeys, partnerId);
  if (appKey) return appKey.integrationId;

  const selectedPartner = findPartner({ partner, partners, partnerId });
  const mapping = getMappings(selectedPartner).find(
    (candidate) => !toolId || candidate.tool === toolId
  );
  return mapping ? mapping.integrationId : '';
};

export const isPartnerConnectedToTool = ({
  allAppKeys = [],
  partner,
  partners = [],
  partnerId,
  toolId,
}) => {
  if (findAppKey(allAppKeys, partnerId)) return true;
  const selectedPartner = findPartner({ partner, partners, partnerId });
  return getMappings(selectedPartner).some(
    (mapping) => mapping.tool === toolId
  );
};
